import { appStore } from 'store/configureStore'

export const commandsApiBasePath =
  process.env.NODE_ENV === 'production'
    ? '/commandsapi'
    : 'https://dev-multitenant.scada-lite.com/commandsapi'
export const multitenantAuthApiBasePath =
  process.env.NODE_ENV === 'production'
    ? '/auth'
    : 'https://dev-multitenant.scada-lite.com/auth'
export const multitenantApiBasePath =
  process.env.NODE_ENV === 'production'
    ? '/api'
    : 'https://dev-multitenant.scada-lite.com/api'
export const multitenantAlertsApiBasePath =
  process.env.NODE_ENV === 'production'
    ? '/alertsapi'
    : 'https://dev-multitenant.scada-lite.com/alertsapi'

export function getFetch(accessToken: string, tenantId) {
  return {
    fetch: async (url: RequestInfo, init?: RequestInit): Promise<Response> => {
      const state = appStore.getState()
      if (!state.multitenantUser) {
        console.error('Multitenant user state is not initialized')
      }

      const aT = accessToken ?? state.multitenantUser.accessToken
      const tenant = tenantId ?? state.multitenantUser.selectedTenant?.id
      const userMail = state.multitenantUser.email
      const userId = state.multitenantUser.id

      const authHeaders = {
        Accept: 'application/json',
        Authorization: `Bearer ${aT}`,
        tenantId: tenant,
      }

      if (userMail) {
        // eslint-disable-next-line
        authHeaders['userEmail'] = userMail
      }
      if (userId) {
        // eslint-disable-next-line
        authHeaders['userId'] = userId
      }
      const headers = init ? { ...init.headers, ...authHeaders } : authHeaders
      const reqInit: RequestInit = init ? { ...init, headers } : { headers }
      return fetch(url, reqInit)
    },
  }
}
